import { render, staticRenderFns } from "./couponPc.vue?vue&type=template&id=98ce8cb6&scoped=true"
import script from "./couponPc.vue?vue&type=script&lang=js"
export * from "./couponPc.vue?vue&type=script&lang=js"
import style0 from "./couponPc.vue?vue&type=style&index=0&id=98ce8cb6&prod&lang=scss&scoped=true"
import style1 from "./couponPc.vue?vue&type=style&index=1&id=98ce8cb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ce8cb6",
  null
  
)

export default component.exports